import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { stopTimer } from '../common/helper';
import PnrTicket from '../common/pnrTicket';

const BusPnr = ({ captchaToken, refreshCaptchaToken }) => {
    useEffect(() => {
        stopTimer();
    }, [])

    return (
        <>
            {<div className='bookingStatus_container' style={{ width: '100%' }}>
                <PnrTicket
                    captchaToken={captchaToken}
                    refreshCaptchaToken={refreshCaptchaToken}
                />
            </div>
            }
        </>
    )
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(BusPnr);
